// Nav entry of Translator (shell/nav.ts collects every routes/*.nav.ts; `order` places it in the rail, the tabs and Lisää).
import { defineNav } from '../shell/nav-entry';

export const nav = defineNav({
  id: 'translator',
  path: '/translator',
  icon: 'translator',
  group: 'find',
  phone: 'tab',
  order: 900,
  load: () => import('./Translator'),
});
